export default __webpack_public_path__ + "static/easy-3bd952bd003213c0678ada8ce804b30d.svg";